import Vue from 'vue';
import VueImportPopup from '@telexpress/vue-import-popup';

Vue.use(VueImportPopup);
